exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".not-activator {\n  width: 100%;\n  height: 0;\n}\n", ""]);

